var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortAmountUpAlt = function SvgSortAmountUpAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#sort-amount-up-alt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.099 4a.6.6 0 0 1-.424-.177L3.098 2.247 1.522 3.823a.604.604 0 0 1-.848 0 .604.604 0 0 1 0-.848l2-2a.604.604 0 0 1 .848 0l2 2a.604.604 0 0 1 0 .848A.6.6 0 0 1 5.1 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.098 13.2a.604.604 0 0 1-.6-.6V1.4c0-.328.272-.6.6-.6s.6.272.6.6v11.2c0 .329-.272.6-.6.6m10.802-2H7.499a.604.604 0 0 1-.6-.6c0-.328.272-.6.6-.6h6.4c.329 0 .601.272.601.6s-.272.6-.6.6m-3.2-4.8H7.498a.604.604 0 0 1-.6-.6c0-.329.272-.6.6-.6h3.2c.329 0 .6.271.6.6s-.271.6-.6.6ZM9.1 4H7.498a.604.604 0 0 1-.6-.6c0-.329.272-.6.6-.6h1.6c.328 0 .6.271.6.6 0 .327-.272.6-.6.6Zm3.2 4.8H7.499a.604.604 0 0 1-.6-.6c0-.328.272-.6.6-.6h4.8c.329 0 .6.272.6.6s-.271.6-.6.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sort-amount-up-alt_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h14v14H.5z"
  })))));
};
export { SvgSortAmountUpAlt as ReactComponent };
export default __webpack_public_path__ + "sort-amount-up-alt.9b4d9528d6ca9342c5c23003a258b8e2.svg";